import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import McpRegularAi from './mcp-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <McpRegularAi {...validProps} />;
}
SvgComponent.iconName = 'mcpRegularAi';

export const McpRegularAiIcon = svgIconWrapper(SvgComponent);
